import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  filteredProducts: [],
  selectedCategory: "Todos",
  searchTerm: "",
  loading: false,
  categories: ['Todos'],
  error: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setProducts: (state, action) => {
      state.products = action.payload;
      state.filteredProducts = filterProducts(action.payload, state.selectedCategory, state.searchTerm);
      state.loading = false;
      state.error = null;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
      state.filteredProducts = filterProducts(state.products, action.payload, state.searchTerm);
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
      state.filteredProducts = filterProducts(state.products, state.selectedCategory, action.payload);
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
});

// Helper function para filtrar produtos
const filterProducts = (products, category, searchTerm) => {
  let filtered = products;
  
  // Filtrar por categoria
  if (category && category !== "Todos") {
    filtered = filtered.filter(product => product.category === category);
  }
  
  // Filtrar por termo de busca
  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    filtered = filtered.filter(product => 
      product.name.toLowerCase().includes(term) ||
      product.producer.toLowerCase().includes(term) ||
      product.category?.toLowerCase().includes(term) ||
      product.code.toLowerCase().includes(term)
    );
  }
  
  return filtered;
};

export const { 
  setProducts, 
  setCategories, 
  setSelectedCategory, 
  setSearchTerm, 
  setLoading,
  setError,
  clearError
} = productsSlice.actions;

export const selectProducts = (state) => {
  const result = state.products.filteredProducts;
  return result;
};
export const selectAllProducts = (state) => {
  const result = state.products.products;
  return result;
};
export const selectSelectedCategory = (state) => state.products.selectedCategory;
export const selectSearchTerm = (state) => state.products.searchTerm;
export const selectProductsLoading = (state) => state.products.loading;
export const selectProductsError = (state) => state.products.error;
export const selectProductCategories = (state) => state.products.categories;

export default productsSlice.reducer;
